import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import { Fund } from 'src/components/Exchange/types';
import { getFundsByKeys } from 'src/utils/funds/funds-utility';
import { toLookup } from 'src/utils/utils';
import { ApplicationState } from '../../types';
import { getUserFundsRaw } from '../UserFunds/userFunds.selectors';

export const getAllFunds = ({ allFunds }: ApplicationState) => allFunds;

export const getAllFundsList = createSelector(
  [getAllFunds],
  (allFunds) => allFunds?.funds ?? []
);

export const getCollegeAllFundsMap = createSelector(
  [getAllFunds],
  ({ collegeFundsMap }) => collegeFundsMap
);
export const getIsLoading = createSelector(
  [getAllFunds],
  ({ isLoading }) => isLoading
);

/**
 * Selects the 'byTicker' fund lookup, or generates a fake lookup to use in its place for College plans.
 * @function
 * @param state
 * @returns {Object.<string, AllFund>}
 */
export const getAllFundsByTicker = createSelector(
  [getAllFunds, getUserFundsRaw],
  ({ byTicker, collegeFundsMap }, userFundsRaw) => {
    if (isEmpty(collegeFundsMap)) {
      return byTicker;
    }

    // College funds don't have a ticker, or any globally unique identifier,
    // and the college all funds map doesn't even know which product type each
    // is for. It does model agreement funds so we can use that to create a hybrid
    // key of ProductType-FundName to use.

    const productTypeByUniqueId = toLookup(
      getFundsByKeys(userFundsRaw),
      (fund: Fund) => fund.uniqueKey,
      (fund: Fund) => fund.productType
    );

    const fakeByTicker = {};

    Object.entries(collegeFundsMap).forEach(([uniqueKey, funds]) =>
      funds.forEach((fund) => {
        const { investmentVehicleKey } = fund;
        if (investmentVehicleKey) {
          fund.trpCode = investmentVehicleKey.trpcode;
        }
        return (fakeByTicker[productTypeByUniqueId[uniqueKey] + fund.name] =
          fund);
      })
    );
    return fakeByTicker;
  }
);
